// extracted by css-extract-rspack-plugin
export default {"sticky":"_67aebc54","drawerOpen":"_70e44588"};